import { Reveal } from "./Reveal";

const PHOTOS = [
  {
    img: "/assets/ga-atlanta.jpg",
    label: "Atlanta Skyline",
    alt: "Downtown Atlanta skyline from the Jackson Street Bridge",
  },
  {
    img: "/assets/ga-forsyth.jpg",
    label: "Forsyth Park · Savannah",
    alt: "The Forsyth Park fountain in Savannah, Georgia",
  },
  {
    img: "/assets/ga-tybee.jpg",
    label: "Tybee Island Light",
    alt: "Tybee Island lighthouse and keeper's house on the Georgia coast",
  },
  {
    img: "/assets/ga-canyon.jpg",
    label: "Providence Canyon",
    alt: "Providence Canyon, Georgia's Little Grand Canyon",
  },
];

export const GeorgiaStrip = () => (
  <section data-testid="georgia-strip" aria-label="Georgia landmarks" className="border-y-2 border-[#F59E0B] bg-[#060D1A]">
    <div className="grid grid-cols-2 lg:grid-cols-4">
      {PHOTOS.map((p, i) => (
        <Reveal key={p.label} delay={i * 0.08} y={20}>
          <figure data-testid={`georgia-photo-${i}`} className="group relative h-44 overflow-hidden sm:h-56">
            <img
              src={p.img}
              alt={p.alt}
              className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#060D1A]/80 via-transparent to-transparent" />
            <figcaption className="absolute bottom-3 left-3 rounded-full bg-[#060D1A]/75 px-3 py-1.5 font-mono text-[9px] font-bold uppercase tracking-[0.2em] text-[#FEF3C7] backdrop-blur-sm sm:text-[10px]">
              {p.label}
            </figcaption>
          </figure>
        </Reveal>
      ))}
    </div>
  </section>
);
